import {
  OnboardingState,
  useOnboardingActions,
  useOnboardingStateMachine,
} from '@app/context/OnboardingStateMachineContext';
import { NavigationSection } from '@app/context/constants';
import { useNavigation } from '@app/hooks/useNavigation';
import { OutlineMobile, OutlineProps } from '@components/block/Quest/Outline/OutlineMobile.tsx';
import { Button } from '@components/ui';
import { Divider } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { SectionList } from './SectionList';
import './quest-outline.sass';

export function Outline(props: OutlineProps) {
  const { activeIds, onSection, sections, saveAndClose = true, superExpertMode } = props;
  const { t } = useTranslation();
  const {
    navigateDashboard,
    navigation: { activeTopic },
  } = useNavigation();
  const { currentState } = useOnboardingStateMachine();
  const { deselectApp } = useOnboardingActions();

  const isFillingQuestionnaire = currentState === OnboardingState.FillingQuestionnaire;

  const handleClick = () => {
    if (isFillingQuestionnaire) {
      deselectApp();
    } else {
      navigateDashboard(NavigationSection.Topic, activeTopic);
    }
  };

  return (
    <>
      <OutlineMobile {...props} />
      <div className="dtQuestOutline hidden md:block">
        <div className="dtQuestOutline__header">{t('route.docs.quest_outline_header', 'Agenda')}</div>
        <SectionList activeIds={activeIds} depth={0} onSection={onSection} sections={sections} superExpertMode={superExpertMode} />
        {saveAndClose && (
          <>
            <Divider />
            <Button onClick={handleClick} data-testid="button-save-and-close" btnColor="white">
              {isFillingQuestionnaire
                ? t('route.docs.button_back_to_selection', 'Zurück zur Auswahl')
                : t('route.docs.button_save_and_close', 'Pausieren & später fortfahren')}
            </Button>
            <p>
              {isFillingQuestionnaire
                ? t('route.docs.hint_back_to_selection', 'Wähle eine andere Anwendung aus.')
                : t(
                    'route.docs.hint_save_and_close',
                    'Wir speichern deinen Fortschritt automatisch und du kannst jederzeit an gleicher Stelle fortfahren. Alles in deinem Tempo.'
                  )}
            </p>
          </>
        )}
      </div>
    </>
  );
}
